import { render, staticRenderFns } from "./configPermisos.vue?vue&type=template&id=f5d7c5f4&"
import script from "./configPermisos.vue?vue&type=script&lang=js&"
export * from "./configPermisos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports